import {getheaders} from "./authService";
import {toDateString} from "./JobService";

const base = "/api/job-complaints";

function request(path, options = {}) {
    return fetch(`${base}${path}`, {
        headers: getheaders(),
        redirect: "follow",
        ...options,
    });
}

export function getJobComplaint(cosJobId) {
    return request(`/job/${encodeURIComponent(cosJobId)}`);
}

export function getComplaintSummaries(cosJobIds) {
    return request("/summary", {method: "POST", body: JSON.stringify(cosJobIds)});
}

export function normalizeComplaint(data) {
    return {
        ...data,
        cosJobId: data.cos_job_id,
        jobDate: data.job_date,
        fullAddress: data.full_address,
        jobType: data.job_type,
        agentName: data.agent_name,
        workerId: data.worker_id,
        workerName: data.worker_name,
        deductionAmount: data.deduction_amount,
        complainedAt: data.complained_at,
        complainedByUsername: data.complained_by_username,
        accountingStatus: data.accounting_status,
        creditPrice: data.credit_price,
        completedAt: data.completed_at,
        completedByUsername: data.completed_by_username,
    };
}

export function saveJobComplaint(complaint) {
    const isUpdate = Boolean(complaint.id);
    const body = isUpdate ? {
        reason: complaint.reason,
        deduction_amount: Number(complaint.deductionAmount || 0),
        image_ids: complaint.images.map(image => image.id),
        version: complaint.version,
    } : {
        cos_job_id: complaint.cosJobId,
        reason: complaint.reason,
        deduction_amount: Number(complaint.deductionAmount || 0),
        image_ids: complaint.images.map(image => image.id),
    };
    return request(isUpdate ? `/${complaint.id}` : "", {
        method: isUpdate ? "PUT" : "POST",
        body: JSON.stringify(body),
    });
}

export function listJobComplaints(startDate, endDate, accounting = false, status) {
    const params = new URLSearchParams();
    if (startDate) params.set("start_date", toDateString(startDate));
    if (endDate) params.set("end_date", toDateString(endDate));
    if (status) params.set("status", status);
    return request(`${accounting ? "/accounting" : ""}?${params.toString()}`);
}

export function updateComplaintAccounting(complaint, creditPrice, accountingStatus) {
    return request(`/${complaint.id}/accounting`, {
        method: "PATCH",
        body: JSON.stringify({
            credit_price: Number(creditPrice || 0),
            accounting_status: accountingStatus,
            version: complaint.version,
        }),
    });
}
